import { API_TARGET_GROUP_PATH } from '~/utils/consts/white-cat/consts'

export const state = () => ({
  targetGroups: []
})

export const getters = {}

export const mutations = {
  UPDATE_TARGET_GOUPS (state, targetGroups) {
    state.targetGroups = targetGroups
  }
}

export const actions = {
  GetTargetGroups ({ commit }, { data }) {
    return new Promise((resolve, reject) => {
      this.$axios.get(API_TARGET_GROUP_PATH, {
        params: {
          ...data
        }
      })
        .then((response) => {
          commit('UPDATE_TARGET_GOUPS', response.data.result)
          resolve()
        })
        .catch((e) => {
          reject(e.response.data.error)
        })
    })
  }
  // CreateGoal

}

export const modules = {}
